import {collateralRatioMinimumPercentage, collateralRatioTresholdPercentage} from 'shareland-common';

export const getBorrowCollateralPositionStyling = (percentage: number) => {
  if (percentage >= collateralRatioTresholdPercentage) {
    return {
      bg: 'bg-upgreen',
      color: 'text-upgreen',
    };
  }

  if (percentage >= collateralRatioMinimumPercentage) {
    return {
      bg: 'bg-yellow-500',
      color: 'text-yellow-500',
    };
  }

  if (percentage > 0.005) {
    return {
      bg: 'bg-downred',
      color: 'text-downred',
    };
  }

  return {
    bg: 'bg-transparent',
    color: 'text-white',
  };
};
